
export const FIRESTORE_CUSTOMER_COLLECTION = "customers";
export const FIRESTORE_USERS_COLLECTION = "users";

// Used to store signin request (with state, challenge, etc.)
export const FIRESTORE_SIGNIN_COLLECTION = "signin";

export const AUTH0_SERVER = "https://fyre.eu.auth0.com";
export const AUTH0_TOKEN_ENDPOINT = `${AUTH0_SERVER}/oauth/token`;

// Used to store email and confirmation code 
export const FIRESTORE_EMAIL_CONFIRMATION_COLLECTION = "email-confirmation";


export const FIRESTORE_REGISTRATIONS_COLLECTION = "registrations";